module.exports = __webpack_public_path__ + "img/Rob Holding.e2194f74.png";